import {
  About,
  Values,
  Navbar,
  Services,
  HeroSection,
  Mission,
  Culture,
  History,
  Contact,
  Footer,
  CoalerPage,
} from "../components";
import TeamSection from "../components/TeamSection";

const Home = () => {
  return (
    <main className="w-full">
      <Navbar />
      <HeroSection />
      <About />
      <Services />
      <CoalerPage />
      <Values />
      <Mission />
      <Culture />
      <History />
      <TeamSection />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
